import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { environment } from 'src/environments/environment';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class BlogService {
  public blogs = []
  public categories

  constructor(
    private apiService: ApiService,
    private translateService: TranslateService,
  ) { 
    this.initialize()
    this.translateService.onLangChange.subscribe(data => {
      this.initialize()
    })
  }

  initialize() {
    let language = this.translateService.currentLang
    this.getData(language)
    this.getCategory(language)
  }

  getData(language) {
    this.apiService.get(`${environment.API}/api/v1/public/blog?language=${language}`).subscribe(
      data => {
        this.blogs = data['rows']
      },
      err => {
        console.error(err)
      }
    )
  }

  getCategory(language) {
    this.apiService.get(`${environment.API}/api/v1/public/blog/category?language=${language}`).subscribe(
      data => {
        this.categories = data
      },
      err => {
        console.error(err)
      }
    )
  }
}
